import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RegistroUsuarioServiceService } from '../../../../../pages/account/registro-afiliado/services/registro-usuario-service.service';
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";


@Component({
  selector: 'app-modal-codigo',
  templateUrl: './modal-codigo.component.html',
  styleUrls: ['./modal-codigo.component.scss']
})
export class ModalCodigoComponent {
  public codigoForm: FormGroup;
  tiempoRestante: number = 0;
  intervalId: any;
  public txtError: string;
  public idUsuario: any;
  public mostrandoCarga: boolean = false;
  public correoUsuario: string;
  public textoInstruccion: string = 'Introduce el código de 4 digitos que hemos enviado a tu cuenta de correo electrónico.';
  public checkout: boolean = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private service: RegistroUsuarioServiceService,
    private router: Router){
  }

  ngOnInit() {
    this.initForm(); 
    this.iniciarTemporizador();
    this.idUsuario = this.service.idUsuario;
    this.correoUsuario = this.service.correoUsuario;
    this.codigoForm.patchValue({
      idUsuario: this.idUsuario,
    });
    this.textoInstruccion = this.service.textoLoginReenvio;
    this.checkout = this.service.checkout;
  }


initForm() {
  this.codigoForm = this.fb.group({
    idUsuario: [],
    cod1: ['', Validators.required],
    cod2: ['', Validators.required],
    cod3: ['', Validators.required],
    cod4: ['', Validators.required]
  });
}

onInput(event: any, nextInputIndex: number) {
  const input = event.target as HTMLInputElement;
  const numericValue = input.value.replace(/[^0-9]/g, '');
  const limitedValue = numericValue.substring(0, 1);
  input.value = limitedValue;
  if (limitedValue && limitedValue.length > 0) {
    const nextInput = document.getElementById('cod' + nextInputIndex) as HTMLInputElement;
    if (nextInput) {
      nextInput.focus();
    }
  }
}

iniciarTemporizador() {
  this.tiempoRestante = 59;
  this.intervalId = setInterval(() => {
    if (this.tiempoRestante > 0) {
      this.tiempoRestante--;
    } else {
      clearInterval(this.intervalId);
    }
  }, 1000);
}

enviarCodigo() {
  this.service.reenviarCodigo(this.correoUsuario).subscribe((result) => {
    // console.log(result);    
  });
  clearInterval(this.intervalId);
  this.iniciarTemporizador();
}

verificarCorreo() {

  const control = this.codigoForm.controls;
  const codigo = `${control.cod1.value}${control.cod2.value}${control.cod3.value}${control.cod4.value}`;

  if(this.codigoForm.invalid) {
    this.txtError = 'Ingrese el código para continuar'
  } else {
    this.codigoForm.get('cod1').setValue('');
    this.codigoForm.get('cod2').setValue('');
    this.codigoForm.get('cod3').setValue('');
    this.codigoForm.get('cod4').setValue('');
    this.service.activarUserCodigo(codigo,this.idUsuario).subscribe((result)=> {
      if(result === true) {
        this.mostrandoCarga = true;
        setTimeout(() => {
          this.mostrandoCarga = false;
          this.toastr.success("Correo verificado correctamente");
          this.redirigirDespuesCarga();    
          this.service.cerrarModal(false);
        }, 3000);

      } else {
        this.txtError = 'El código es incorrecto';
        this.codigoForm.get('cod1').setValue('');
        this.codigoForm.get('cod2').setValue('');
        this.codigoForm.get('cod3').setValue('');
        this.codigoForm.get('cod4').setValue('');
      };
    },(err) => {
      this.txtError = 'Ocurrió un error al ingresar el código';
      this.codigoForm.get('cod1').setValue('');
      this.codigoForm.get('cod2').setValue('');
      this.codigoForm.get('cod3').setValue('');
      this.codigoForm.get('cod4').setValue('');
    });
  }
}

redirigirDespuesCarga() {
  this.service.obtenerStatusVerificacion(true);
  
  if(this.checkout === false) {
    this.router.navigateByUrl(this.service.rutaCodVerif); 
  } else {
    this.service.cerrarModalLogin(true);
    this.service.cerrarModal(false);
    this.service.cerrarModalRegister(false);
  }
}

closeModal() {
  this.service.cerrarModal(false);
  this.service.vieneDeCheckout(false);
}

}
